import React from "react";
import "./ProcessSection.css";
import proc1Icon from "../assets/icons/proc1.svg";
import proc2Icon from "../assets/icons/proc2.svg";
import proc3Icon from "../assets/icons/proc3.svg";
import proc4Icon from "../assets/icons/proc4.svg";
import deliveryIcon from "../assets/icons/delivery.svg";
import sectionLabel from "../assets/icons/section_label.svg";

const features = [
  {
    icon: proc1Icon,
    text: "Practitioner-selected formulas based on your intake",
  },
  {
    icon: proc2Icon,
    text: "Customized according to your symptoms and constitution",
  },
  { icon: proc3Icon, text: "Adjusted over time as your body changes" },
  { icon: proc4Icon, text: "Rooted in traditional Chinese medicine diagnosis" },
  { icon: deliveryIcon, text: "Delivered directly to your door nationwide" },
];

function ProcessSection({ onStartQuestionnaire }) {
  return (
    <section className="process-section">
      <div className="process-container">
        <div className="process-left">
          <div className="process-section-label flex-center">
            <img src={sectionLabel} alt="" width="192" height="32" />
          </div>
          <h2 className="process-title">
            Beyond generic supplements.{" "}
            <span className="process-title-accent">
              Personalized herbal medicine with practitioner guidance.
            </span>
          </h2>
        </div>
        <div className="process-right">
          {features.map((feat, i) => (
            <div className="process-feature-card" key={i}>
              <div className="process-feature-icon">
                <img src={feat.icon} alt="" width="64" height="64" />
              </div>
              <p className="process-feature-text">{feat.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
